import { useTheme } from "@material-ui/core";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { ClientTypeService } from "../../services/ClientTypeService";
import Authorize from "../Authorize";
import Filteration from "../Filteration/Filteration";
import { RUDTable } from "../Table/RUDTable";
import UserContext from "../UserContext";
import AddClientType from "./AddClientType";

const ClientType = () => {
    const [clientTypeAdded, setClientTypeAdded] = useState(0);
    const [filter, setFilter] = useState({
        search: "",
    });
    const { user } = useContext(UserContext);
    const history = useHistory();

    const [clearFilters, setClearFilters] = useState(false);
    const theme = useTheme();

    const handleFilterClear = () => {
        setClearFilters(!clearFilters);
        setFilter({
            search: "",
        });
    };

    return (
        <>
            <Authorize
                opName="CREATE CLIENT_TYPE"
                // fallback={
                //     <AuthorizeFallback message="You're not authorized to create a new employee" />
                // }
            >
                <AddClientType setClientTypeAdded={setClientTypeAdded} />
            </Authorize>

            <RUDTable
                getter={(page, limit) =>
                    ClientTypeService.getClientType(page, limit, {
                        search: filter.search ? filter.search : null,

                        // role: filter.role ? filter.role : null,
                        // classroom: filter.classroom ? filter.classroom : null,
                    })
                }
                editor={ClientTypeService.updateClientType}
                deletor={(ids) =>
                    ClientTypeService.deleteClientType(ids[0] as any)
                }
                readables={{
                    id: "ID",
                    name: "Name",
                }}
                rowsPreprocessor={(r) => ({
                    ...r,
                    deletionId: r.id,
                })}
                ops={{
                    read: "READ CLIENT_TYPE",
                    edit: "EDIT CLIENT_TYPE",
                    delete: "DELETE CLIENT_TYPE",
                }}
                updatingAgents={[clientTypeAdded, filter.search]}
                editables={[
                    {
                        name: "name",
                        type: "textfield",
                        label: "Name",
                        isRequired: true,
                    },
                ]}
                filters={
                    <Filteration
                        handleClear={handleFilterClear}
                        filter={filter}
                        setFilter={setFilter}
                    />
                }
                customCols={[]}
                storageKey="clientType"
            />
        </>
    );
};

export default ClientType;
